import { Modal, ModalBody, ModalHeader } from "reactstrap";
import React, { useEffect, useRef, useState } from "react";

type GamePreviewDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  videoSrc: string;
  title?: string;
};

export const GamePreviewDialog: React.FC<GamePreviewDialogProps> = ({isOpen , onClose, videoSrc, title = 'Game Preview'}: GamePreviewDialogProps)=> {

  const videoRef = useRef<HTMLVideoElement>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if(isOpen) {
      setLoading(true);
      setError("");
    }
  }, [isOpen])

  const handleCanPlay = () => {
    setLoading(false)
  }

  const handleError = () => {
    setError('Failed to load video. Please try again.');
    setLoading(false);
  }

  return (

    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader
        className="mt-0 modal-header--background"
        toggle={onClose} closeButton={true}
      >
        <h6 className="mb-0 font-size-20 text-white">
          {title}
        </h6>
      </ModalHeader>
      <ModalBody>
        {loading && (
          <div>Loading game preview...</div>
        )}

        {error && (
          <div className="cs-txt-danger">{error}</div>
        )}

        {videoSrc && !error &&
          <video width="100%" height="auto"
                 ref={videoRef}
                 controls
                 controlsList="nodownload nofullscreen noremoteplayback"
                 disablePictureInPicture
                 onContextMenu={(e) => e.preventDefault()}
                 autoPlay
                 muted={true}
                 onCanPlay={handleCanPlay}
                 onError={handleError}
          >
            <source src={videoSrc} type="video/mp4" />
            <div>Your browser does not support the video tag.</div>
          </video>
        }
      </ModalBody>
    </Modal>
  );
}